import { SummaryContainer } from './Summary.container';
import { attachReactComponent } from '../common/attachReactComponent';

attachReactComponent(SummaryContainer);
